// src/utils/notificationRefresh.js

/**
 * Utility to trigger notification refresh across the app
 * This uses a custom event to notify the NotificationBell component to refresh
 */

export const NOTIFICATION_REFRESH_EVENT = 'notificationRefresh';

/**
 * Trigger notification refresh
 * Call this after any POST, PUT, or PATCH operation that should trigger a notification
 */
export function triggerNotificationRefresh() {
  const event = new CustomEvent(NOTIFICATION_REFRESH_EVENT);
  window.dispatchEvent(event);
}

/**
 * Listen for notification refresh events
 * @param {Function} callback - Function to call when refresh is triggered
 * @returns {Function} Cleanup function to remove event listener
 */
export function onNotificationRefresh(callback) {
  window.addEventListener(NOTIFICATION_REFRESH_EVENT, callback);
  return () => window.removeEventListener(NOTIFICATION_REFRESH_EVENT, callback);
}
